export const SET_NETWORK_STATUS = 'network/SET_NETWORK_STATUS'

let initialState = {
    status: true
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_NETWORK_STATUS:
            return {
                ...state,
                status: action.status
            }

        default:
            return state
    }
}

export const setNetworkStatus = (status) => {
    return dispatch => {
        dispatch({
            type: SET_NETWORK_STATUS,
            status
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/network.js